import type {
    FC
} from "react";
import type ICommandPageProps from "./type";

const CommandPage: FC<ICommandPageProps> = () => {
    return null;
};
export default Object.assign(CommandPage, {
    commandPart: "page"
});
